import { Component, Input } from '@angular/core'
import { ElementsUserMini } from 'elements-sdk'

@Component({
  selector: 'avatar',
  templateUrl: './avatar.component.pug',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() user: ElementsUserMini
  @Input() size: string

  getSize () {
    return {
      xs: 16,
      sm: 25,
      lg: 100,
      xl: 150,
    }[this.size] ?? 50
  }
}
